import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UserService } from 'app/_core/services/user.service';
import { NodeTabRequest } from 'app/request/interfaces/request.interface';
import { RequestService } from 'app/request/request.service';

@Injectable()
export class ClaimService {
  constructor(
    private readonly userService: UserService,
    private readonly requestService: RequestService
  ) {}

  /**
   * Check if logged user can submit form by uuid
   * @param stepUuid
   * @returns Observable true | false
   */
  canSubmit(stepUuid: string): Observable<boolean> {
    return this.findFormConfigByUuid(stepUuid).pipe(
      map((tab: NodeTabRequest) => {
        const { claims } = tab;
        const { userClaims } = this.userService.getUser();
        const intersection = userClaims.filter((userClaim) => claims.includes(userClaim));

        return intersection.length > 0;
      })
    );
  }

  /**
   * Search valid form by uuid
   * @param stepUuid
   * @returns form {@link NodeTabRequest}
   */
  findFormConfigByUuid(stepUuid: string): Observable<NodeTabRequest> {
    return this.getRequestTabs().pipe(
      map((tabs: NodeTabRequest[]) => {
        return tabs.find((tab) => tab.formConfiguration.submit.stepUuid === stepUuid);
      })
    );
  }

  /**
   * Get all only valid forms
   * @returns only valid forms
   */
  private getRequestTabs(): Observable<NodeTabRequest[]> {
    return this.requestService.getRequestTabs().pipe(
      map((tabs: NodeTabRequest[]) => {
        return this.extractForms(tabs);
      })
    );
  }

  /**
   * Recursive function to get all valid forms from tabs requests
   * @param tabs
   * @returns only valid forms
   */
  private extractForms(tabs: NodeTabRequest[]): NodeTabRequest[] {
    let completList = [];

    tabs.forEach((tab: NodeTabRequest) => {
      if (tab.children) {
        const childrenForms = this.extractForms(tab.children);
        completList = completList.concat(childrenForms);
      } else {
        completList.push(tab);
      }
    });

    return completList;
  }
}
